import styled from 'styled-components';

export const StyledDotsList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  margin-top: 1rem;
  margin-bottom: 1rem;
  display: inline-block;
`;
